t = require('app/scripts/views/internal/teacup-with-helpers')('list_copy')

module.exports = t.renderable ({ canCopyOpen, canCopyTotal, name }) ->
  t.div ->
    canCopy = canCopyOpen && canCopyTotal
    t.label ->
      t.format 'name'
    t.textarea '.js-autofocus', { name: 'name' }, ->
      t.text name

    t.span '.js-limit-exceeded.error', { class: t.classify({ hide: canCopy }) }, ->
      t.format(if !canCopyOpen then 'open-limit-exceeded' else 'total-limit-exceeded')

    t.input '.primary.wide.js-submit', { type: 'submit', value: t.l('create-list'), disabled: !canCopy }
